module.exports = __webpack_public_path__ + "static/chal_fct1-f72470775bab31ff1d75d56cccb0bc41.jpg";